export const TOOL_TASK = 'assign-accounts-entitlements';
export const TOOL_TITLE = 'Assign Entitlements To Accounts';
export const TOOL_PROGRESS_LABEL = 'Progress of assigning entitlements to accounts...';
export const FILE_NAME = 'Assign-entitlements-to-accounts-report';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once assigning entitlements to accounts finishes';
export const FILE_HEADERS = {
    accountId: 'Account Id',
    accountName: 'Account Name',
    role: 'Role',
    resources: 'Resources',
    grantName: 'Grant Name',
    actionStatus: 'Action Status',
};
